import { Suspense } from 'react';
import { Http404Lazy } from './http404-lazy';

/** Use as a catch-all element so the 404 page (`http404.tsx`) loads in its own async chunk. */
export function Http404Suspense() {
    return (
        <Suspense
            fallback={
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100vh',
                        background: 'radial-gradient(#fff, #ccc)'
                    }}
                >
                    <span style={{ color: '#888' }}>…</span>
                </div>
            }
        >
            <Http404Lazy />
        </Suspense>
    );
}
